import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
export const EyePasswordBtn = ({showPassword, setShowPassword,hasError }) => {
    console.log("hasError======>",hasError)
    return (
        <>
        <button
        className={`eyes-button ${hasError ? "with-error" : ""}`}
        onClick={() => setShowPassword(!showPassword)}
        type="button"
    >
        {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
    </button>
        </>
    )
 
}

